export const LESSONS = '/lessons'
export const STUDENT_LESSONS_LIST = '/:ccls_module_id/student-lessons'
export const LESSONS_LIST = '/module/:ccls_module_id/lessons'
export const LESSONS_DISCUSSIONS_LIST = '/module/:ccls_module_id/discussions'
export const LESSONS_ATTENDANCE_LIST = '/module/:ccls_module_id/lesson/:lesson_id/attendance'
export const LESSONS_ATTENDANCE_SINGLE =
  '/module/:ccls_module_id/lesson/:lesson_id/group/:group_id/attendance/:lesson_slot_id'
